import './index.scss';

(function () {
	/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @date    15/4/19
 * @since   1.0.0
 *
 * @param   object $block The block jQuery element.
 * @param   object attributes The block attributes (only available when editing).
 * @return  void
 */
	const blockClass = 'wp-block-apk-clock';

	function initGallery(blockClock) {
		const vr = blockClock.querySelector('.apk-vr');
		if (!vr) return;

		const preview = vr.querySelector('.apk-vr__preview');
		const overlay = vr.querySelector('.apk-vr__overlay');
		const viewer = vr.querySelector('.apk-vr__viewer');

		if (!preview || !viewer) return;

		const activateVR = () => {
			preview.style.display = 'none';
			if (overlay) overlay.style.display = 'none';
			viewer.style.display = 'block';
		};

		preview.addEventListener('click', activateVR);
		if (overlay) overlay.addEventListener('click', activateVR);
	}

	/**
	 * Initialize each block on page load (front end).
	 */
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll(`.${blockClass}`).forEach(initGallery);
	});

	/**
	 * Initialize dynamic block preview (editor).
	 */
	const initializeBlock = ($block) => {
		const blockClock = $block[0].querySelector(`.${blockClass}`);
		if (blockClock) initGallery(blockClock);
	};

	if (window.acf) {
		window.acf.addAction(
			`render_block_preview/type=${blockClass}`,
			initializeBlock
		);
	}
})();